// Robust helper to compute answers/comments count from a post-like object
export default function getAnswersCount(item) {
  if (!item) return 0;

  const count = (v) => {
    if (v == null) return 0;
    if (Array.isArray(v)) return v.length;
    if (typeof v === "number") return Number.isFinite(v) ? v : 0;
    if (typeof v === "object") return Object.keys(v).length;
    const n = parseInt(String(v || "").trim(), 10);
    return Number.isFinite(n) ? n : 0;
  };

  // Try every possible field name the backend might use
  const candidates = [
    item?.answers,
    item?.comments,
    item?.answersCount,
    item?.commentsCount,
    item?.answers_count,
    item?.comments_count,
    item?.totalComments,
    item?.totalAnswers,
    item?.total_comments,
    item?.total_answers,
    item?.commentsNb,
    item?.answersNb,
    item?.nbComments,
    item?.nbAnswers,
    item?.commentCount,
    item?.answerCount,
    item?.repliesCount,
    item?.replies,
    item?.ai_response // Add this field to check for AI-generated responses
  ];

  for (const candidate of candidates) {
    const n = count(candidate);
    if (n > 0) return n;
  }

  return 0;
}